/**
 * @summary     app.misc
 * @description App JS misc controller
 * @version     1.0
 	> 1.0 Initial version
		- 01/21/2016 SG
 * @file        app.misc.js
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** Examples:
*/

app.addFeature(
	"misc",
	function(){
		/*
			NOTE:
				This is used for pho requests that may have logic used for cacheing
		*/
		this.emptyResponse = {
			responseText : "{}"
		};

		this.guid = function(domSafe){
			return (domSafe?"D":"") + "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
				var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
				return v.toString(16);
			});
		}

		this.isValueTrue = function(value, options){
			var trueValues = ['1','true','okay','yes','y'],
				settings = app.utils.copy(
					{
						trueValues : trueValues,
						useTruthy : false
					},
					options || {},
					false,
					false,
					true
				);

			if(settings.useTruthy && value){
				return true;
			}

			try {
				return settings.trueValues.indexOf(value.toString().toLowerCase()) !== -1;
			}
			catch(e){
				return false;
			}
		};

		this.isValueFalse = function(value, options){
			var falseValues = ['0','false','no','n'],
				settings = app.utils.copy(
					{
						falseValues : falseValues,
						nullFalse : true,
						undefinedFalse : true,
						useTruthy : false
					},
					options || {},
					false,
					false,
					true
				);

			if(settings.useTruthy && !value){
				return true;
			}
			if(settings.nullFalse && value === null){
				return true;
			}
			if(settings.undefinedFalse && value === undefined){
				return true;
			}

			try {
				return settings.falseValues.indexOf(value.toString().toLowerCase()) !== -1;
			}
			catch(e){
				return false;
			}
		};


		return this;
	}
);
